angular.module('access.Utils')
    .constant('IS_INTERNET_EXPLORER', angular.isDefined(document.documentMode));
